export default {
      id: "play-usage",
      viewBox: "0 0 31 35",
      url: "../../assets/" + "sprite.svg#play-usage",
      toString: function () {
        return this.url;
      }
    }